/* Petname - preview ao vivo FRENTE / VERSO (porta do preview da Tray para a Shopify + Easify).
   - Fundo: as duas ultimas fotos da galeria do produto (penultima = frente em branco, ultima = verso em branco),
     mesma regra da Tray.
   - Texto/icone sao desenhados por cima, com as mesmas coordenadas por modelo da Tray (espaco de referencia 240x270).
   - Le as escolhas direto dos campos do Easify (nao altera nada no pedido).
   - Debug: abra a pagina com ?pn-debug=1 para ver o que foi lido dos campos. */
(function () {
  'use strict';

  var REF_W = 240, REF_H = 270, FS = 0.8;

  /* ---------- Coordenadas por modelo (copiadas do SHAPE_DATA da Tray) ---------- */
  var SHAPES = {
    osso:         { f: { nomeY: 138, nomeSize: 22, nomeW: 162, telY: 161, telSize: 12, dpX: 102, dpY: 50,  dpSz: 46, dpYI: 168, dpSzI: 38 }, v: { cy: 153, lh: 18 },
                  /* Osso / Candy / Glow: verso com QR tem a frase AO LADO do QR (QR a esquerda, frase a direita) */
                  vSide: { cy: 0.567, qx: 0.36, qr: 0.26, tx: 0.7, tw: 0.3, fs: 0.05, maxLine: 12 } },
    coracao:      { f: { nomeX: 120, nomeY: 138, nomeSize: 28, nomeW: 130, telY: 161, telSize: 12, dpX: 102, dpY: 176, dpSz: 36, dpBelow: true }, v: { cy: 142, lh: 16 }, noLine3: true },
    hexagono:     { f: { nomeY: 151, nomeSize: 22, nomeW: 152, telY: 173, telSize: 12, dpX: 96, dpY: 184, dpSz: 44 }, v: { cy: 152, lh: 18 },
                  /* Hexagono / Candy / Glow: verso com QR tem Texto 360 (cima) e Telefone (baixo) em arco, como o Circulo M */
                  vArc: { cx: 0.5, cy: 0.5, rt: 0.2, rb: 0.23, fsT: 0.05, fsB: 0.045, nomeSz: 0.06, nomeDy: 0, iconSz: 0.1, iconDy: 0, qr: 0.28 } },
    circulo_m:    { f: { nomeY: 156, nomeSize: 21, nomeW: 175, telY: 178, telSize: 12, dpX: 96, dpY: 188, dpSz: 42 }, v: { cy: 153, lh: 18, fs: 10 },
                  /* verso com QR: Texto 360 (cima) e Telefone (baixo) em arco em volta do QR. Medidas em fracao da largura; ajuste com ?pn-guides=1&pn-arc=cx,cy,rt,rb */
                  vArc: { cx: 0.5, cy: 0.567, rt: 0.2, rb: 0.23, fsT: 0.05, fsB: 0.045, nomeSz: 0.06, nomeDy: 0, iconSz: 0.1, iconDy: 0, qr: 0.3 } },
    circulo_mini: { f: { nomeY: 152, nomeSize: 15, nomeW: 150, telY: 171, telSize: 10, dpX: 106, dpY: 179, dpSz: 26 }, v: { cy: 155, lh: 14, fs: 10 }, noLine3: true },
    maze:         { f: { nomeY: 151, nomeSize: 22, nomeW: 152, telY: 173, telSize: 12, dpX: 96, dpY: 184, dpSz: 44 }, v: { cy: 152, lh: 18 }, noFrente: true },
    /* Gravatinhas (G, Case Tag, Mini): so FRENTE. Nome no meio, icone/QR embaixo dele, frase 360 em arco em cima e embaixo.
       Medidas do arco em FRACAO DA LARGURA da foto (cx/cy: centro; rt/rb: raio do arco de cima/de baixo;
       fsT/fsB: tamanho maximo da letra; nome/icone: deslocamento vertical do centro e tamanho).
       Ajuste ao vivo na pagina com ?pn-arc=cx,cy,rt,rb,nomeDy,iconeDy e ?pn-guides=1 (mostra os circulos). */
    gravatinha:   { noVerso: true, arc: { cx: 0.5, cy: 0.5, rt: 0.11, rb: 0.125, fsT: 0.05, fsB: 0.04, nomeSz: 0.065, nomeDy: 0, iconSz: 0.12, iconDy: 0, qr: 0.2 } }
  };

  /* Limites de caracteres (PN_LIMITS_BY_SHAPE da Tray) */
  var LIMITS = {
    _default:     { nome: 15, line2: 20, phrase: 22 },
    gravatinha:   { phrase: 30 },
    circulo_m:    { phrase: 20 },
    coracao:      { phrase: 16 },
    circulo_mini: { nome: 14, line2: 10, phrase: 15 }
  };
  function limit(shape, key) {
    var s = LIMITS[shape] || {};
    return s[key] != null ? s[key] : LIMITS._default[key];
  }

  /* Fontes do seletor (Classic / Charm / Cute / Fun) */
  var FONTS = {
    classic: { css: 'Arial,sans-serif', w: '700' },
    charm:   { css: "'Dancing Script','Brush Script MT',cursive", w: '400' },
    cute:    { css: "'PnCheri',cursive", w: '400' },
    fun:     { css: "'PnMinimalize',sans-serif", w: '400' }
  };

  /* Se uma foto de preview nao seguir a regra penultima/ultima, force aqui: { 'handle-do-produto': { F: 1, V: 3 } } */
  var INDEX_OVERRIDES = {};

  var DEBUG = /[?&]pn-debug=1/.test(location.search);

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var shapeKey = null, sd = null, images = [], alts = [], handle = '';
  var root = null, stage = null, bg = null, ov = {}, badge = null;
  var memIcon = undefined, memPhrase = '', memPhraseMode = '';
  var side = 'F', lastOpenStep = -1, raf = 0, observer = null, resizeObs = null;

  /* ---------- Modelo a partir do handle ---------- */
  function detectShape(h) {
    if (/gravatinha/.test(h)) return 'gravatinha';       /* arcos 360, so frente */
    if (/maze/.test(h)) return 'maze';
    if (/^tag-osso/.test(h)) return 'osso';
    if (/^tag-coracao/.test(h)) return 'coracao';
    if (/^tag-hexagono/.test(h)) return 'hexagono';
    if (/^tag-circulo-mini/.test(h)) return 'circulo_mini';
    if (/^tag-circulo-m-/.test(h)) return 'circulo_m';
    return null;
  }

  /* ---------- Imagem de fundo (regra da Tray: penultima = frente, ultima = verso) ---------- */
  function imageFor(s) {
    var m = window.PN_PREVIEW_MAP && window.PN_PREVIEW_MAP[handle];
    if (m && m[s]) return m[s];
    var re = s === 'V' ? /(preview[-_ ]?)?verso/i : /(preview[-_ ]?)?frente/i;
    for (var a = 0; a < alts.length; a++) { if (alts[a] && re.test(alts[a])) return images[a]; }
    var n = images.length;
    if (!n) return '';
    var ov = INDEX_OVERRIDES[handle];
    if (ov && ov[s] != null && images[ov[s]]) return images[ov[s]];
    if (n < 3) return images[n - 1];
    return s === 'V' ? images[n - 1] : images[n - 2];
  }

  /* ---------- Leitura dos campos do Easify ---------- */
  function groups() {
    var r = $('.po-options-root');
    if (!r) return [];
    return $$(':scope > .po-option-root', r).filter(function (o) { return o.querySelector('.po-group-root'); });
  }
  function visible(el) { return !!(el && (el.offsetParent !== null || el.getClientRects().length)); }
  function inputsOf(g) { return $$('.po-textField-input', g).filter(visible); }

  function isSelectedEl(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.getAttribute('aria-pressed') === 'true' || el.getAttribute('aria-checked') === 'true' || el.getAttribute('aria-selected') === 'true' || el.getAttribute('data-selected') === 'true') return true;
    var cls = (el.className && el.className.baseVal !== undefined ? el.className.baseVal : el.className) || '';
    /* camelCase do Easify (ex.: ...optionItemSelected) tambem conta */
    if (/selected|checked|active|pressed/i.test(cls) && !/unselected|unchecked|inactive|notselected|not-selected|disabled/i.test(cls)) return true;
    var inp = el.matches && el.matches('input') ? el : el.querySelector && el.querySelector('input[type=radio],input[type=checkbox]');
    return !!(inp && inp.checked);
  }
  function cleanLabel(t) { return (t || '').replace(/\s*\(\+?\s*R\$\s*[\d.,]+\)\s*$/i, '').replace(/\s+/g, ' ').trim(); }

  function iconFromItem(item) {
    var img = item && (item.matches && item.matches('img') ? item : item.querySelector('img'));
    if (!img) return null;
    var name = (img.getAttribute('alt') || '').trim();
    if (/^nenhum|^none$|^sem /i.test(name) || /nenhum/i.test(item.textContent || '')) return null;
    return { src: img.currentSrc || img.src, name: name };
  }
  function readIcon(g) {
    var sw = g && $('.po-imageSwatches-root', g);
    if (!sw) return null;
    var imgs = $$('img', sw);
    for (var i = 0; i < imgs.length; i++) {
      var el = imgs[i];
      for (var k = 0; k < 5 && el && el !== sw.parentElement; k++, el = el.parentElement) {
        if (isSelectedEl(el)) return iconFromItem(el.querySelector('img') ? el : imgs[i]);
      }
    }
    return memIcon === undefined ? null : memIcon;      /* fallback: ultimo clique */
  }
  function readFont(g) {
    if (!g) return 'classic';
    var txt = '';
    var r = $('.po-fontPickerSwatches-swatchInput:checked', g);
    if (r) {
      txt = (r.value || '') + ' ' + (r.getAttribute('aria-label') || '') + ' ' + (r.title || '');
      var lab = r.closest('label') || (r.id && g.querySelector('label[for="' + r.id + '"]')) || r.parentElement;
      if (lab) txt += ' ' + (lab.textContent || '');
    } else {
      /* sem input marcado: procura o botao/swatch marcado pelo estado visual */
      var sw = $$('[class*="fontPickerSwatches"]', g).filter(isSelectedEl);
      for (var i = 0; i < sw.length; i++) txt += ' ' + (sw[i].textContent || '') + ' ' + (sw[i].getAttribute('value') || '');
    }
    txt = txt.toLowerCase();
    if (/cheri|\bcute\b/.test(txt)) return 'cute';
    if (/minimalize|\bfun\b/.test(txt)) return 'fun';
    if (/dancing|script|charm/.test(txt)) return 'charm';
    if (/open sans|classic|arial/.test(txt)) return 'classic';
    return 'classic';
  }
  function readMode(g) {
    var b = g && $('.po-dropdown-root .po-select-button', g);
    if (!b || b.querySelector('.po-select-placeholder')) return '';
    return cleanLabel(b.textContent);
  }
  function phraseOptions() {
    var r = $('.po-options-root');
    if (!r) return [];
    return $$('.po-option-root', r).filter(function (o) {
      if (o.querySelector('.po-group-root')) return false;           /* so opcoes folha, nao os cartoes dos passos */
      var l = $('.po-label-label', o);
      return l && /frase/i.test(l.textContent) && visible(o);
    });
  }
  function readPhrase(g, mode) {
    var opts = phraseOptions();
    for (var i = 0; i < opts.length; i++) {
      var els = $$('button, [role=radio], [role=option], label', opts[i]);
      for (var j = 0; j < els.length; j++) {
        if (isSelectedEl(els[j])) return cleanLabel(els[j].textContent);
      }
    }
    /* fallback: ultimo clique, enquanto o modo do verso nao mudou */
    return (memPhrase && memPhraseMode === mode && opts.length) ? memPhrase : '';
  }

  function labelOfInput(inp) {
    var box = inp, lab = null;
    for (var i = 0; i < 6 && box && !lab; i++) {
      box = box.parentElement;
      if (box) lab = box.querySelector('.po-label-root, label');
    }
    return lab ? lab.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
  }
  /* No verso com QR a ordem dos campos muda de produto para produto (Telefone vem antes ou depois do texto):
     acha pelo rotulo. Sem rotulo "telefone", usa a ordem: 1o = texto de cima, 2o = de baixo. */
  function qrTexts(st) {
    var f = st.vFields || [], tel = null, txt = null, i;
    for (i = 0; i < f.length; i++) { if (/telefone|whats|celular/.test(f[i].label)) { tel = f[i]; break; } }
    if (tel) { for (i = 0; i < f.length; i++) { if (f[i] !== tel) { txt = f[i]; break; } } return { txt: txt ? txt.value : '', tel: tel.value }; }
    return { txt: f[0] ? f[0].value : '', tel: f[1] ? f[1].value : '' };
  }

  function readState() {
    var gs = groups();
    var g2 = gs[1], g3 = gs[2], g4 = gs[3];
    var early = [gs[0], gs[1], gs[2]];
    if (sd.noFrente) {                                  /* Maze: so 2 passos (Cor e Verso), sem frente/estilo */
      g2 = null; g3 = null; g4 = gs[1];
      early = [gs[0]];
    }
    var in2 = g2 ? inputsOf(g2) : [];
    var in4 = $$('.po-options-root .po-textField-input').filter(function (i) {
      return visible(i) && !early.some(function (e) { return e && e.contains(i); });
    });
    var mode = readMode(g4);
    var phrase = readPhrase(g4, mode);
    var st = {
      nome: (in2[0] ? in2[0].value : '').trim().slice(0, limit(shapeKey, 'nome')),
      line2: (in2[1] ? in2[1].value : '').trim().slice(0, limit(shapeKey, 'line2')),
      font: readFont(g3),
      icon: readIcon(g3),
      mode: mode,
      phrase: phrase,
      vInputs: in4.map(function (i) { return (i.value || '').trim(); }),
      vFields: in4.map(function (i) { return { label: labelOfInput(i), value: (i.value || '').trim() }; })
    };
    st.kind = /qr/i.test(mode) ? 'qr' : (phrase ? 'phrase' : (/(livre|texto|escrev|digit|person)/i.test(mode) ? 'free' : (phrase ? 'phrase' : 'none')));
    return st;
  }

  /* ---------- Desenho ---------- */
  function splitPhrase(txt, max) {
    if (!txt || txt.length <= max) return [txt || '', ''];
    var mid = Math.floor(txt.length / 2);
    var sp = txt.lastIndexOf(' ', mid); if (sp <= 0) sp = txt.indexOf(' ', mid);
    if (sp <= 0) return [txt.slice(0, max), txt.slice(max)];
    return [txt.slice(0, sp).trim(), txt.slice(sp).trim()];
  }
  function pctX(x) { return (x / REF_W * 100) + '%'; }
  function pctY(y) { return (y / REF_H * 100) + '%'; }

  /* QR ILUSTRATIVO (nao e um codigo valido/escaneavel): mostra onde o QR vai ficar no verso.
     O QR real e enviado pelo cliente via WhatsApp (ou criado pela Petname). */
  var qrSrc = '';
  function qrPlaceholder() {
    if (qrSrc) return qrSrc;
    var N = 21, cells = '', seed = 7;
    function rnd() { seed = (seed * 1103515245 + 12345) & 0x7fffffff; return seed / 0x7fffffff; }
    function finder(x, y) {
      /* anel preto (contorno) + miolo preto, sem fundo branco: o centro fica transparente */
      return '<rect x="' + (x + 0.5) + '" y="' + (y + 0.5) + '" width="6" height="6" fill="none" stroke="#000" stroke-width="1"/>' +
             '<rect x="' + (x + 2) + '" y="' + (y + 2) + '" width="3" height="3" fill="#000"/>';
    }
    for (var r = 0; r < N; r++) {
      for (var c = 0; c < N; c++) {
        var inFinder = (r < 8 && c < 8) || (r < 8 && c > N - 9) || (r > N - 9 && c < 8);
        if (!inFinder && rnd() > 0.52) cells += '<rect x="' + c + '" y="' + r + '" width="1" height="1" fill="#000"/>';
      }
    }
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 ' + (N + 2) + ' ' + (N + 2) + '" shape-rendering="crispEdges">' +
      cells + finder(0, 0) + finder(N - 7, 0) + finder(0, N - 7) + '</svg>';
    qrSrc = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
    return qrSrc;
  }

  function build() {
    var gal = $('media-gallery');
    if (!gal || $('.pn-live')) return !!$('.pn-live');
    root = document.createElement('div');
    root.className = 'pn-live';
    root.innerHTML =
      '<div class="pn-live__tabs">' +
        '<button type="button" data-side="F">Frente</button>' +
        '<button type="button" data-side="V">Verso</button>' +
        '<button type="button" data-side="P">Fotos do produto</button>' +
      '</div>' +
      '<div class="pn-live__stage">' +
        '<img class="pn-live__bg" alt="" decoding="async">' +
        '<div class="pn-live__ov">' +
          '<svg class="pn-arc" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"></svg>' +
          '<div class="pn-t pn-nome"></div><div class="pn-t pn-tel"></div>' +
          '<img class="pn-icon" alt="">' +
          '<img class="pn-qr" alt="">' +
          '<div class="pn-t pn-v pn-v1"></div><div class="pn-t pn-v pn-v1b"></div>' +
          '<div class="pn-t pn-v pn-v2"></div><div class="pn-t pn-v pn-v3"></div>' +
        '</div>' +
        '<span class="pn-live__badge">FRENTE</span>' +
      '</div>';
    gal.parentNode.insertBefore(root, gal);
    stage = $('.pn-live__stage', root);
    bg = $('.pn-live__bg', root);
    ov = {
      arc: $('.pn-arc', root), nome: $('.pn-nome', root), tel: $('.pn-tel', root), icon: $('.pn-icon', root), qr: $('.pn-qr', root),
      v: [$('.pn-v1', root), $('.pn-v1b', root), $('.pn-v2', root), $('.pn-v3', root)]
    };
    badge = $('.pn-live__badge', root);
    $$('.pn-live__tabs button', root).forEach(function (b) {
      b.addEventListener('click', function () { setSide(b.getAttribute('data-side'), true); });
    });
    bg.addEventListener('load', function () {
      if (bg.naturalWidth) stage.style.aspectRatio = bg.naturalWidth + ' / ' + bg.naturalHeight;
      schedule();
    });
    if (window.ResizeObserver) { resizeObs = new ResizeObserver(schedule); resizeObs.observe(stage); }
    /* esconde abas que o modelo nao tem */
    if (sd.noFrente) $('[data-side="F"]', root).hidden = true;
    if (sd.noVerso) $('[data-side="V"]', root).hidden = true;
    return true;
  }

  function setSide(s, manual) {
    if (s === 'F' && sd.noFrente) s = 'V';
    if (s === 'V' && sd.noVerso) s = 'F';
    side = s;
    var gal = $('media-gallery');
    if (gal) gal.classList.toggle('pn-gallery-hidden', s !== 'P');
    root.setAttribute('data-side', s);
    $$('.pn-live__tabs button', root).forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-side') === s); });
    badge.textContent = s === 'V' ? 'VERSO' : 'FRENTE';
    if (s !== 'P') {
      var src = imageFor(s);
      if (src && bg.getAttribute('data-src') !== src) {
        bg.setAttribute('data-src', src);
        bg.src = src;
      }
    }
    schedule();
  }

  function applyFont(el, fontKey) {
    var f = FONTS[fontKey] || FONTS.classic;
    el.style.fontFamily = f.css; el.style.fontWeight = f.w;
  }

  /* ---------- Gravatinhas: texto 360 em arco (cima e baixo), nome no meio, icone/QR embaixo ---------- */
  function arcParams(base) {
    var a = {}, k;
    for (k in base) a[k] = base[k];
    var m = /[?&]pn-arc=([^&]+)/.exec(location.search);
    if (m) {
      var v = decodeURIComponent(m[1]).split(',').map(parseFloat), keys = ['cx', 'cy', 'rt', 'rb', 'nomeDy', 'iconDy'];
      keys.forEach(function (key, i) { if (!isNaN(v[i])) a[key] = v[i]; });
    }
    return a;
  }
  function escXml(t) { return (t || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function renderArc(st, w, base, verso) {
    var h = stage.clientHeight || w;
    var A = arcParams(base);
    var nomeTxt = verso ? '' : st.nome;
    var cx = A.cx * w, cy = A.cy * h, rt = A.rt * w, rb = A.rb * w;

    /* texto de cima = frase pronta ou texto livre; de baixo = 2o campo (telefone) */
    var top = '', bot = '';
    if (st.kind === 'phrase') { top = st.phrase; bot = st.vInputs[0] || ''; }
    else if (st.kind === 'qr') { var qt = qrTexts(st); top = qt.txt; bot = qt.tel; }
    else { top = st.vInputs[0] || ''; bot = st.vInputs[1] || ''; }
    top = (top || '').trim().toUpperCase().slice(0, limit(shapeKey, 'phrase'));
    bot = (bot || '').trim().toUpperCase().slice(0, limit(shapeKey, 'phrase'));

    function fit(txt, base, r, maxRad) {                  /* a letra encolhe se o texto nao cabe no arco */
      var avail = r * maxRad, cw = 0.72;
      var fs = base * w;
      if (txt.length * fs * cw > avail) fs = avail / (txt.length * cw);
      return Math.max(fs, 7);
    }
    var svg = '<defs>' +
      '<path id="pn-arc-t" d="M' + cx + ',' + (cy + rt) + ' A' + rt + ',' + rt + ' 0 1 1 ' + cx + ',' + (cy - rt) + ' A' + rt + ',' + rt + ' 0 1 1 ' + cx + ',' + (cy + rt) + '"/>' +
      '<path id="pn-arc-b" d="M' + cx + ',' + (cy - rb) + ' A' + rb + ',' + rb + ' 0 1 0 ' + cx + ',' + (cy + rb) + ' A' + rb + ',' + rb + ' 0 1 0 ' + cx + ',' + (cy - rb) + '"/>' +
      '</defs>';
    if (top) {
      svg += '<text font-family="Arial,sans-serif" font-weight="700" fill="#000" letter-spacing="1" font-size="' + fit(top, A.fsT, rt, 4.2) + '">' +
        '<textPath href="#pn-arc-t" startOffset="50%" text-anchor="middle">' + escXml(top) + '</textPath></text>';
    }
    if (bot) {
      svg += '<text font-family="Arial,sans-serif" font-weight="700" fill="#000" letter-spacing="1" font-size="' + fit(bot, A.fsB, rb, 2.5) + '">' +
        '<textPath href="#pn-arc-b" startOffset="50%" text-anchor="middle">' + escXml(bot) + '</textPath></text>';
    }
    if (DEBUG || /[?&]pn-guides=1/.test(location.search)) {
      svg += '<circle cx="' + cx + '" cy="' + cy + '" r="' + rt + '" fill="none" stroke="#e11" stroke-dasharray="4 3"/>' +
             '<circle cx="' + cx + '" cy="' + cy + '" r="' + rb + '" fill="none" stroke="#18f" stroke-dasharray="4 3"/>' +
             '<circle cx="' + cx + '" cy="' + cy + '" r="2" fill="#e11"/>';
    }
    ov.arc.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    ov.arc.innerHTML = svg;
    ov.arc.style.display = 'block';

    /* Conteudo do meio: ocupa a faixa livre ENTRE os dois arcos (do fim das letras de cima ate o comeco das de baixo).
       Com nome: nome em cima e caricatura/QR centrados no que sobra; sem nome: caricatura/QR centrados na faixa toda. */
    var nudge = (A.nomeDy || 0) * w;                      /* ajuste fino vertical do conteudo do meio */
    var fsBused = bot ? fit(bot, A.fsB, rb, 2.5) : A.fsB * w;
    var bandTop = cy - rt + nudge;
    var bandBot = cy + rb - 0.72 * fsBused + nudge;
    var gap = 0.01 * w;
    var wantIcon = !verso && st.kind !== 'qr' && !!st.icon;
    var wantQr = st.kind === 'qr';
    var n = ov.nome;
    applyFont(n, st.font);
    var nsz = A.nomeSz * w * (st.font === 'fun' ? 1.2 : 1);
    var maxW = rb * 1.7;
    if (nomeTxt.length * nsz * 0.6 > maxW) nsz = maxW / (nomeTxt.length * 0.6);
    nsz = Math.max(Math.round(nsz), 8);
    var nameH = nomeTxt ? nsz * 1.2 : 0;
    var below0 = bandTop + (nameH ? nameH + gap : 0), below1 = bandBot;
    var hasBelow = wantIcon || wantQr;
    var nameY;
    if (!nomeTxt) nameY = 0;
    else if (hasBelow) nameY = bandTop + nameH / 2;
    else nameY = (bandTop + bandBot) / 2;                 /* so nome: no meio da faixa */
    n.style.left = (cx / w * 100) + '%';
    n.style.top = (nameY / h * 100) + '%';
    n.style.fontSize = nsz + 'px';
    n.textContent = nomeTxt;
    n.style.display = nomeTxt ? 'block' : 'none';
    ov.tel.style.display = 'none';
    ov.v.forEach(function (el) { el.style.display = 'none'; });

    var ic = ov.icon, q = ov.qr;
    var availH = Math.max(below1 - below0, 10);
    var midY = (below0 + below1) / 2;
    function place(el, maxFrac) {
      var sz = Math.min(availH * 0.94, maxFrac * w);
      el.style.left = (cx / w * 100) + '%'; el.style.top = (midY / h * 100) + '%';
      el.style.width = (sz / w * 100) + '%'; el.style.height = (sz / h * 100) + '%';
      el.style.display = 'block';
    }
    if (wantQr) {
      if (!q.getAttribute('src')) q.src = qrPlaceholder();
      place(q, A.qr); ic.style.display = 'none';
    } else {
      q.style.display = 'none';
      if (wantIcon) { ic.src = st.icon.src; place(ic, A.iconSz); } else { ic.style.display = 'none'; }
    }
  }

  /* Osso: QR a esquerda e a frase "ao lado do QR" a direita (ate 3 linhas) */
  function wrapWords(txt, max) {
    var words = (txt || '').split(/\s+/).filter(Boolean), lines = [], cur = '';
    words.forEach(function (wd) {
      if (!cur) cur = wd;
      else if ((cur + ' ' + wd).length <= max) cur += ' ' + wd;
      else { lines.push(cur); cur = wd; }
    });
    if (cur) lines.push(cur);
    return lines.slice(0, 3);
  }
  function renderSide(st, w) {
    var h = stage.clientHeight || w;
    var A = sd.vSide;
    ov.arc.style.display = 'none';
    ov.nome.style.display = 'none'; ov.tel.style.display = 'none'; ov.icon.style.display = 'none';
    var cy = A.cy * h;
    var q = ov.qr;
    if (!q.getAttribute('src')) q.src = qrPlaceholder();
    q.style.left = (A.qx * 100) + '%'; q.style.top = (cy / h * 100) + '%';
    q.style.width = (A.qr * 100) + '%'; q.style.height = (A.qr * w / h * 100) + '%';
    q.style.display = 'block';
    var qt = qrTexts(st);
    var txt = (qt.txt || '').trim().toUpperCase().slice(0, 36);
    var tel = (qt.tel || '').trim().slice(0, 20);
    var lines = wrapWords(txt, A.maxLine).slice(0, 2);
    var longest = lines.reduce(function (m, l) { return Math.max(m, l.length); }, 1);
    var fs = Math.max(Math.min(A.fs * w, (A.tw * w) / (longest * 0.66)), 7);
    /* frase (negrito) e, logo abaixo, o telefone (menor) */
    var items = lines.map(function (l) { return { t: l, fs: fs, bold: true }; });
    if (tel) items.push({ t: tel, fs: Math.max(Math.min(fs * 0.85, (A.tw * w) / (tel.length * 0.6)), 7), bold: false, gap: fs * 0.35 });
    var total = 0;
    items.forEach(function (it) { it.h = it.fs * 1.25; total += it.h + (it.gap || 0); });
    var y = cy - total / 2;
    ov.v.forEach(function (el, i) {
      var it = items[i];
      if (it) {
        y += (it.gap || 0);
        el.textContent = it.t;
        el.style.left = (A.tx * 100) + '%'; el.style.top = ((y + it.h / 2) / h * 100) + '%';
        el.style.fontSize = Math.round(it.fs) + 'px'; el.style.fontFamily = 'Arial,sans-serif'; el.style.fontWeight = it.bold ? '700' : '400';
        el.style.display = 'block';
        y += it.h;
      } else { el.style.display = 'none'; }
    });
  }

  function render() {
    raf = 0;
    if (!root || !stage || side === 'P') return;
    var w = stage.clientWidth || REF_W;
    var sc = w / REF_W;
    var st = readState();
    if (sd.arc) { renderArc(st, w, sd.arc, false); if (DEBUG) debugPanel(st); return; }
    if (side === 'V' && st.kind === 'qr' && sd.vArc) { renderArc(st, w, sd.vArc, true); if (DEBUG) debugPanel(st); return; }
    if (side === 'V' && st.kind === 'qr' && sd.vSide) { renderSide(st, w); if (DEBUG) debugPanel(st); return; }
    ov.arc.style.display = 'none';
    var hasIcon = !!st.icon;
    var f = sd.f;
    var isV = side === 'V';

    /* FRENTE */
    var nX = f.nomeX || 120;
    var nY = (!hasIcon || f.dpBelow) ? f.nomeY : f.nomeY - 18;
    var tY = (!hasIcon || f.dpBelow) ? f.telY : f.telY - 18;
    var n = ov.nome;
    n.style.left = pctX(nX); n.style.top = pctY(nY);
    applyFont(n, st.font);
    var len = st.nome.length;
    var fsBase = Math.round(f.nomeSize * FS * sc) - 4;
    if (st.font === 'fun') fsBase = Math.round(fsBase * 1.2);
    var fit = Math.max(Math.floor((f.nomeW || 162) / (f.nomeSize * FS * 0.58)), 1);
    n.style.fontSize = Math.max(len > fit ? Math.round(fsBase * fit / len) : fsBase, 8) + 'px';
    n.textContent = st.nome;
    n.style.display = (!isV && st.nome) ? 'block' : 'none';

    var t = ov.tel;
    t.style.left = pctX(nX); t.style.top = pctY(tY);
    t.style.fontSize = Math.max(Math.round(f.telSize * FS * sc) - 3, 6) + 'px';
    t.textContent = st.line2;
    t.style.display = (!isV && st.line2) ? 'block' : 'none';

    var ic = ov.icon;
    if (!isV && st.icon) {
      var szI = f.dpSzI || f.dpSz;
      ic.src = st.icon.src;
      ic.style.left = pctX(f.dpX + f.dpSz / 2);
      ic.style.top = pctY(f.dpYI != null ? f.dpYI : (f.dpY + f.dpSz / 2));
      ic.style.width = (szI / REF_W * 100) + '%';
      ic.style.height = (szI / REF_H * 100) + '%';
      ic.style.display = 'block';
    } else { ic.style.display = 'none'; }

    /* VERSO */
    var lines = ['', '', '', ''];
    if (st.kind === 'phrase') {
      var parts = splitPhrase(st.phrase, limit(shapeKey, 'phrase'));
      lines[0] = parts[0]; lines[1] = parts[1];
      lines[2] = st.vInputs[0] || '';
      lines[3] = sd.noLine3 ? '' : (st.vInputs[1] || '');
    } else if (st.kind === 'free') {
      lines[0] = st.vInputs[0] || ''; lines[2] = st.vInputs[1] || ''; lines[3] = sd.noLine3 ? '' : (st.vInputs[2] || '');
    }
    var q = ov.qr;
    if (isV && st.kind === 'qr') {
      var qsz = sd.v.qr || 76;                              /* lado em px no espaco de referencia 240x270 */
      if (!q.getAttribute('src')) q.src = qrPlaceholder();
      q.style.left = '50%';
      q.style.top = pctY(sd.v.cy);
      q.style.width = (qsz / REF_W * 100) + '%';
      q.style.height = (qsz / REF_H * 100) + '%';
      q.style.display = 'block';
    } else { q.style.display = 'none'; }

    var count = lines.filter(Boolean).length || 1;
    var lh = sd.v.lh / REF_H;              /* fracao da altura */
    var cy = sd.v.cy / REF_H;
    var y0 = cy - (count - 1) * lh / 2, yi = 0;
    var base = Math.round((sd.v.fs || 13) * FS * sc) - 2;
    ov.v.forEach(function (el, i) {
      var txt = lines[i];
      if (isV && txt) {
        el.textContent = txt;
        el.style.top = ((y0 + yi * lh) * 100) + '%';
        el.style.left = '50%';
        el.style.fontSize = Math.max(txt.length > 18 ? Math.round(base * 18 / txt.length) : base, 7) + 'px';
        el.style.fontFamily = 'Arial,sans-serif';
        el.style.fontWeight = i < 2 ? '700' : '400';
        el.style.display = 'block'; yi++;
      } else { el.style.display = 'none'; }
    });

    if (DEBUG) debugPanel(st);
  }

  function schedule() { if (!raf) raf = requestAnimationFrame(render); }

  /* ---------- Troca automatica pelo passo aberto ---------- */
  function openStepIndex() {
    var gs = groups();
    for (var i = 0; i < gs.length; i++) {
      var w = gs[i].querySelector('.po-group-collapseWrapper');
      if (w && w.classList.contains('po-group-collapseWrapperOpen')) return i;
    }
    return -1;
  }
  function syncStep() {
    var idx = openStepIndex();
    if (idx === lastOpenStep) return;
    lastOpenStep = idx;
    if (idx < 0) return;
    if (side === 'P') return;                       /* quem esta vendo as fotos nao e puxado de volta */
    setSide(idx === 3 ? 'V' : 'F', false);
  }

  /* ---------- Debug ---------- */
  function debugPanel(st) {
    var p = $('#pn-debug');
    if (!p) {
      p = document.createElement('pre'); p.id = 'pn-debug';
      p.style.cssText = 'position:fixed;right:8px;bottom:8px;z-index:99999;max-width:360px;max-height:50vh;overflow:auto;margin:0;padding:10px;background:#111;color:#9f9;font:11px/1.4 monospace;border-radius:8px;white-space:pre-wrap;';
      document.body.appendChild(p);
    }
    p.textContent = JSON.stringify({
      handle: handle, shape: shapeKey, side: side, images: images.length, bg: bg && bg.getAttribute('data-src'),
      grupos: groups().length, passoAberto: openStepIndex() + 1, estado: st,
      memoria: { icon: memIcon, phrase: memPhrase, phraseMode: memPhraseMode },
      fonteDom: (function () { var g3 = groups()[2]; var r = g3 && $('.po-fontPickerSwatches-swatchInput:checked', g3); return r ? ('checked value=' + r.value + ' id=' + r.id) : 'nenhum input checked'; })(),
      iconeDom: (function () { var sw = $('.po-imageSwatches-root'); if (!sw) return 'sem .po-imageSwatches-root'; return $$('img', sw).slice(0, 3).map(function (im) { var e = im, c = []; for (var k = 0; k < 3 && e && e !== sw; k++, e = e.parentElement) c.push(e.tagName + '.' + String(e.className).slice(0, 80)); return c; }); })(),
      fraseDom: (function () { var g4 = sd.noFrente ? groups()[1] : groups()[3]; if (!g4) return 'sem grupo do verso'; var o = phraseOptions()[0]; if (!o) return 'sem opcao com label FRASE'; return $$('button, [role=radio], label', o).slice(0, 3).map(function (e) { return e.tagName + '.' + String(e.className).slice(0, 80) + ' aria-pressed=' + e.getAttribute('aria-pressed'); }); })()
    }, null, 1);
  }

  /* ---------- Boot ---------- */
  function start() {
    var easify = $('.po-productPageOptions-root');
    if (!easify) { setTimeout(start, 400); return; }
    if (!build()) { setTimeout(start, 400); return; }
    setSide(sd.noFrente ? 'V' : 'F', false);
    var target = easify.closest('.shopify-app-block') || easify;
    observer = new MutationObserver(function () { syncStep(); schedule(); });
    observer.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'value', 'aria-checked', 'aria-pressed', 'aria-selected'] });
    document.addEventListener('input', schedule, true);
    document.addEventListener('change', schedule, true);
    document.addEventListener('click', function (e) {
      var tg = e.target;
      var sw = tg.closest && tg.closest('.po-imageSwatches-root');
      if (sw) {
        var item = tg;
        for (var q = 0; q < 6 && item && item !== sw; q++, item = item.parentElement) { if (item.querySelector && item.querySelector('img') && item.querySelectorAll('img').length === 1) break; }
        memIcon = iconFromItem(item && item !== sw ? item : null);
      }
      var po = tg.closest && tg.closest('.po-option-root');
      if (po && /frase/i.test(($('.po-label-label', po) || {}).textContent || '')) {
        var b = tg.closest('button, [role=radio], [role=option], label');
        if (b) { memPhrase = cleanLabel(b.textContent); memPhraseMode = readMode(sd.noFrente ? groups()[1] : groups()[3]); }
      }
      if (e.target.closest && e.target.closest('.pn-live')) return;      /* clique nas nossas abas nao re-sincroniza */
      setTimeout(function () { syncStep(); schedule(); }, 80);
    }, true);
    window.addEventListener('resize', schedule);
    lastOpenStep = openStepIndex();                  /* estado inicial: so reage a MUDANCA de passo */
    schedule();
  }

  function init() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    handle = m[1];
    shapeKey = detectShape(handle);
    if (!shapeKey) return;
    sd = SHAPES[shapeKey];
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var med = (p.media || []).filter(function (m) { return m.media_type === 'image'; });
        var urls = med.length ? med.map(function (m) { return m.src; }) : (p.images || []);
        alts = med.length ? med.map(function (m) { return m.alt || ''; }) : [];
        images = urls.map(function (u) { return u + (u.indexOf('?') === -1 ? '?width=1200' : '&width=1200'); });
        var pm = window.PN_PREVIEW_MAP && window.PN_PREVIEW_MAP[handle];
        if (!images.length && !pm) return;
        start();
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();